import React, { useState, useEffect } from 'react';

const CardCheckerView = ({ isDarkMode }) => {
  // Calcular la fecha de lanzamiento 15 días a partir de ahora
  const launchDate = new Date();
  launchDate.setDate(launchDate.getDate() + 15);
  const launchTimestamp = launchDate.getTime();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isLaunched, setIsLaunched] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = launchTimestamp - now;

      if (distance < 0) {
        clearInterval(timer);
        setIsLaunched(true);
      } else {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000),
        });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [launchTimestamp]);

  return (
    <div className="h-full flex flex-col items-center justify-center p-6">
      <div className={`text-center p-8 rounded-xl shadow-lg backdrop-blur-md border ${isDarkMode ? 'bg-gray-800/70 border-gray-700 text-white' : 'bg-white/90 border-gray-200 text-gray-900'} animate-fade-in-up`}>
        {isLaunched ? (
          <>
            <svg className="mx-auto h-24 w-24 text-green-500 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M9 12l2 2 4-4m6.938 4.938A9 9 0 0112 21c-3.638 0-6.938-1.807-8.938-4.938m0 0A9 9 0 013 12c0-3.638 1.807-6.938 4.938-8.938m0 0A9 9 0 0112 3c3.638 0 6.938 1.807 8.938 4.938m0 0L21 12m-9 9V3" />
            </svg>
            <h3 className={`text-3xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              ¡Checker de Tarjetas Lanzado!
            </h3>
            <p className={`text-lg ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              La herramienta ya está disponible. ¡A verificar!
            </p>
          </>
        ) : (
          <>
            <svg className="mx-auto h-24 w-24 text-indigo-500 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className={`text-3xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
              ¡Prepárate para el futuro del Checker!
            </h3>
            <p className={`text-lg ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              Nuestro checker de tarjetas estará disponible en:
            </p>
            <div className="mt-6 flex justify-center space-x-4 font-mono text-4xl font-bold">
              <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                <span className="block text-indigo-500">{timeLeft.days.toString().padStart(2, '0')}</span>
                <span className={`block text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Días</span>
              </div>
              <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                <span className="block text-indigo-500">{timeLeft.hours.toString().padStart(2, '0')}</span>
                <span className={`block text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Horas</span>
              </div>
              <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                <span className="block text-indigo-500">{timeLeft.minutes.toString().padStart(2, '0')}</span>
                <span className={`block text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Minutos</span>
              </div>
              <div className={`p-4 rounded-lg ${isDarkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
                <span className="block text-indigo-500">{timeLeft.seconds.toString().padStart(2, '0')}</span>
                <span className={`block text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>Segundos</span>
              </div>
            </div>
            <p className={`mt-4 text-sm ${isDarkMode ? 'text-gray-500' : 'text-gray-700'}`}>
              ¡La espera valdrá la pena!
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default CardCheckerView;